import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getIqamaData = createAsyncThunk("api/iqama", async (token) => {
    try {
        const response = await nodeinstance.get("/iqama", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const IqamaDataSlice = createSlice({
    name: "iqama",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getIqamaData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getIqamaData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getIqamaData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getIqamaData };
export default IqamaDataSlice.reducer;
